/* istanbul ignore file */
// this is basically a copy from volto-pdf-block
/* eslint-disable */
import React from 'react';
import loadable from '@loadable/component';
import { flattenToAppURL } from '@plone/volto/helpers';
import NavigationToolbar from './PDFNavigation';

const LoadablePDFViewer = loadable(() => import('./PDFViewer'), {
  fallback: () => <div>Loading PDF file...</div>,
  ssr: false,
});
const CSS_UNITS = 96 / 72;

const downloadUrl = (url) => (url.indexOf('@@download') === -1 ? `${flattenToAppURL(url)}/@@download/file` : url);

const PDFFileViewer = ({ data }) => {
  let dataUrl = downloadUrl(data.url);
  //noinspection JSUnusedLocalSymbols
  const [size, setSize] = React.useState();

  return (
    <div className="pdf-viewer-block">
      {dataUrl && (
        <LoadablePDFViewer
          document={{
            url: dataUrl,
          }}
          css="pdf-viewer"
          navigation={NavigationToolbar}
          showToolbar={!data.hideToolbar}
          showNavbar={!data.hideNavbar}
          showPagesPreview={data.showPagesPreview}
          page={parseInt(data.initialPage || 1)}
          initial_scale={data.initial_scale}
          initial_scale_ratio={data.initial_scale_ratio}
          enableScroll={!data.disableScroll}
          fitPageWidth={data.fitPageWidth}
          onPageRenderSuccess={(page, canvasEl, viewport) => {
            setSize([`${Math.round(viewport.width / CSS_UNITS)}px`, `${Math.round(viewport.height / CSS_UNITS)}px`]);
          }}
        />
      )}
    </div>
  );
};

export default PDFFileViewer;
